export const KPI_CARDS = [
  {
    label: "Total Users",
    key: "totalUsers",
    icon: "fas fa-users",
    iconClass: "text-primary",
    bgColor: "rgba(94, 114, 228, 0.1)",
    trend: "Live",
    trendClass: "text-success",
    route: "/admin/users-list",
    valueClass: "kpi-value",
  },
  {
    label: "Active Today",
    key: "activeToday",
    icon: "fas fa-bolt",
    iconClass: "text-success",
    bgColor: "rgba(45, 206, 137, 0.1)",
    trend: "Today",
    trendClass: "text-success",
    route: "/admin/users-list",
    valueClass: "kpi-value",
  },
  {
    label: "New Signups",
    key: "newSignupsToday",
    icon: "fas fa-user-plus",
    iconClass: "text-warning",
    bgColor: "rgba(251, 99, 64, 0.1)",
    trend: "New",
    trendClass: "text-muted",
    valueClass: "kpi-value",
  },
  {
    label: "Total Messages",
    key: "totalMessages",
    icon: "far fa-comment-dots",
    iconClass: "text-info",
    bgColor: "rgba(17, 205, 239, 0.1)",
    trend: "Volume",
    trendClass: "badge badge-pill badge-info py-1",
    isBadge: true,
    valueClass: "kpi-value",
  },
  {
    label: "Active Rooms",
    key: "activeRooms",
    icon: "fas fa-door-open",
    iconClass: "text-danger",
    bgColor: "rgba(245, 54, 92, 0.1)",
    trend: "Active",
    trendClass: "text-success",
    route: "",
    valueClass: "kpi-value",
  },
  {
    label: "Wallet Volume",
    key: "walletVolume",
    icon: "fas fa-wallet",
    iconClass: "text-success",
    bgColor: "rgba(45, 206, 137, 0.1)",
    trend: "High",
    isBadge: true,
    trendClass: "badge badge-pill badge-primary py-1",
    valueClass: "kpi-value",
  },
];